export default {
  en: {
    email: 'Email',
    general: 'General',
    sender: 'Sender',
    recipient: 'Recipient',
    senderName: 'Sender Name',
    replyEmail: 'Reply Email',
    includeAgentEmail: 'Include Agent Email',
    yes: 'Yes',
    no: 'No',
    contactPersonOption: 'Contact Person Option',
    primary: 'Primary',
    secondary: 'Secondary',
    stopSale: 'Stop Sale',
    sendTo: 'Send to',
    allAgent: 'All Agent',
    specific: 'Specific',
    searchToSend: 'Search to send',
    addMoreEmail: 'Add more email',
    cc: 'Cc',
    addMoreCCEmail: 'Add more cc email',
    bcc: 'Bcc',
    addMoreBCCEmail: 'Add more bcc email',
    subject: 'Subject',
    body: 'Body',
    attachment: 'Attachment',
    addAttachment: '+ Add Attachment',
    attachmentRemark: '*total limit 3 mb',
    sendEmail: 'Send email',
    reset: 'Reset',
    fileSizeOverMessage: 'Total file size must be smaller than 3MB.',
    market: 'Market',
    agent: 'Agent',
    agentType: 'Agent Type',
    more: 'more',
    useCommaToSeparateEmailMessage: '* Use , to separate email',
    otherSenderName: '- Other -',
    sendEmailSuccessTitle: 'Success',
    sendEmailSuccessMessage: 'Send Email Success',
    emptyReplyEmailErrorMessage: 'Empty Reply Email.',
    notSelectContactPersonOptionErrorMessage: 'Please select Option Include Agent Email or Contact Person Option or enter email to send.',
    notSelectAgentErrorMessage: 'Please select agent or enter email to send.',
    emptyEmailSubjectErrorMessage: 'Empty Email Subject.',
    emptyEmailBodyErrorMessage: 'Empty Email Body.',
    otherEmail: 'Other Email'
  },
  th: {
    email: 'อีเมล',
    general: 'ทั่วไป',
    sender: 'ผู้ส่ง',
    recipient: 'ผู้รับ',
    senderName: 'ชื่อผู้ส่ง',
    replyEmail: 'อีเมลตอบกลับ',
    includeAgentEmail: 'ส่งถึงอีเมลตัวแทน',
    yes: 'ส่ง',
    no: 'ไม่ส่ง',
    contactPersonOption: 'ตัวเลือกผู้ติดต่อ',
    primary: 'ผู้ติดต่อหลัก',
    secondary: 'ผู้ติดต่อรอง',
    stopSale: 'หยุดการขาย',
    sendTo: 'ส่งไปยัง',
    allAgent: 'ตัวแทนทั้งหมด',
    specific: 'กำหนดเอง',
    searchToSend: 'ค้นหา',
    addMoreEmail: 'เพิ่มอีเมล',
    cc: 'Cc',
    addMoreCCEmail: 'เพิ่ม cc อีเมล',
    bcc: 'Bcc',
    addMoreBCCEmail: 'เพิ่ม bcc อีเมล',
    subject: 'หัวข้อ',
    body: 'เนื้อหา',
    attachment: 'แนบไฟล์',
    addAttachment: '+ เพิ่มไฟล์',
    attachmentRemark: '*ขนาดไฟล์ทั้งหมดไม่เกิน 3 mb',
    sendEmail: 'ส่งอีเมล',
    reset: 'ล้างทั้งหมด',
    fileSizeOverMessage: 'ขนาดของไฟล์ทั้งหมดรวมกันต้องไม่เกิน 3MB',
    market: 'ตลาด',
    agent: 'ตัวแทน',
    agentType: 'ประเภทตัวแทน',
    more: 'เพิ่มเติม',
    useCommaToSeparateEmailMessage: ' * ใช้เครื่องหมาย , เพื่อแบ่งอีเมล',
    otherSenderName: '- อื่นๆ -',
    sendEmailSuccessTitle: 'สำเร็จ',
    sendEmailSuccessMessage: 'ส่งอีเมลสำเร็จ',
    emptyReplyEmailErrorMessage: 'กรุณาระบุอีเมลตอบกลับ',
    notSelectContactPersonOptionErrorMessage: 'กรุณาเลือกตัวเลือกของผู้ติดต่อ',
    notSelectAgentErrorMessage: 'กรุณาเลือกตัวแทน หรือ ระบุอีเมลที่ต้องการส่ง',
    notEnterEmailErrorMessage: 'กรุณาระบุอีเมลสำหรับการส่ง',
    emptyEmailSubjectErrorMessage: 'กรุณาระบุหัวหัวหข้อ',
    emptyEmailBodyErrorMessage: 'กรุณาระบุเนื้อหา',
    otherEmail: 'อีเมลเพิ่มเติม'
  }
}
